// I don't think this is being used anymore -Adam
import React from 'react';
import { PropTypes } from 'prop-types';
import { Formik, Form } from 'formik';
import SubmitButton from '@atoms/SubmitButton';
import Radios from '@atoms/Radios';
import CheckboxGroup from '@atoms/CheckboxGroup';
import LoadingInline from '@molecules/LoadingInline';

const StepThree = ({ data, onNext, loading }) => (
    <div>
        <h2 className="mb-3">...</h2>
        {/* <div className="mb-4">...</div> */}
        {loading || !data ? (
            <LoadingInline />
        ) : (
            <Formik onSubmit={onNext} initialValues={data}>
                {formik => (
                    <Form>
                        <Radios
                            label="..."
                            name="..."
                            value={formik.values.primaryInterest}
                            options={[{ value: '...', label: '...' }]}
                            required
                        />
                        <CheckboxGroup label="..." name="..." options={[{ value: '...', label: '...' }]} required />
                        <SubmitButton>Save</SubmitButton>
                    </Form>
                )}
            </Formik>
        )}
    </div>
);

StepThree.propTypes = {
    data: PropTypes.object,
    onNext: PropTypes.func,
    loading: PropTypes.bool,
};

export default StepThree;
